import { ExclamationMarkTriangle } from "components/icons/generated";
import Badge from "ds/components/Badge";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import Tooltip from "ds/components/Tooltip";
import {
  NO_PRIVATE_WORKERS_AVAILABLE_MESSAGE,
  NO_PUBLIC_WORKERS_AVAILABLE_MESSAGE,
} from "views/Account/WorkerPool/constants";

import { WorkerPoolsTableRow } from "../types";

const WorkerPoolsTableQueueCell = ({
  item: row,
  ...cellProps
}: TableSimpleCellProps<WorkerPoolsTableRow>) => {
  const runsCount =
    row.kind === "private"
      ? row.workerPool.schedulableRunsCount
      : row.publicWorkerPool.schedulableRunsCount;
  const availableWorkers =
    row.kind === "private" ? row.workerPool.workersCount : row.publicWorkerPool.parallelism;
  const hasWarning = availableWorkers === 0 && runsCount > 0;
  const warningMessage =
    row.kind === "private"
      ? NO_PRIVATE_WORKERS_AVAILABLE_MESSAGE
      : NO_PUBLIC_WORKERS_AVAILABLE_MESSAGE;

  return (
    <TableSimpleCell {...cellProps}>
      {hasWarning ? (
        <Tooltip
          on={(props) => (
            <Badge
              variant="red"
              startIcon={ExclamationMarkTriangle}
              text={`${runsCount}`}
              type="weak"
              {...props}
            />
          )}
        >
          {warningMessage}
        </Tooltip>
      ) : (
        <TableCellText>{runsCount}</TableCellText>
      )}
    </TableSimpleCell>
  );
};

export default WorkerPoolsTableQueueCell;
